import fetch from 'isomorphic-fetch';
import Constants from '../definitions/constants';
import InterfaceTooling from '../tooling/interfaceTooling';

const EntityTableToolingOld = {
  getListQueryParams: (listState, tableDescriptor, searchText, showDisabledEntities) => {
    return {
      page: listState.page,
      per_page: listState.pageSize,
      order_fields: [listState.orderBy ? listState.orderBy 
        : (tableDescriptor.columns[0].sortField ? 
           tableDescriptor.columns[0].sortField : tableDescriptor.columns[0].key)],
      order_directions: [listState.orderByDirection ? listState.orderByDirection
        : Constants.crudGenerator.orderTypes.ASC],
      fields_are: !showDisabledEntities ? ["active"] : null,
      searches_are: !showDisabledEntities ? [true] : null,
      fields_like: searchText!="" ? 
        [tableDescriptor.generalTextSearchFields] : null,
      searches_like: searchText!="" ? 
        tableDescriptor.generalTextSearchFields.map(item => {
          return searchText;
        }) : null
    };
  },
  fetchListNextPage: async (event, listState, getQueryParamsFunction, fetchListFunction) => {
    var page = +event.target.dataset.targetpage;
    if(listState.status === 200 && listState.page<=listState.totalPages) {
      await fetchListFunction(Object.assign(getQueryParamsFunction(), {
        page: page,
      }), true);
    }  
  },
  fetchListOrder: async (event, listState, getQueryParamsFunction, fetchListFunction) => {
    var direction = Constants.crudGenerator.orderTypes.ASC;
    if(event.target.dataset.field == listState.orderBy) {
      direction = listState.orderByDirection == Constants.crudGenerator.orderTypes.ASC ? 
        Constants.crudGenerator.orderTypes.DESC : Constants.crudGenerator.orderTypes.ASC;
    }
    await fetchListFunction(Object.assign(getQueryParamsFunction(), {
      page: 1,
      order_fields: [event.target.dataset.field],
      order_directions: [direction],
    }));
  },
  fetchListSearch: async (event, getQueryParamsFunction, fetchListFunction) => {
    await fetchListFunction(Object.assign(getQueryParamsFunction(),{
      page: 1,
    }));
  },
  handleOnChangeTopControls: (event, state, topControlsStateName, fetchListSearch, timeoutObject) => {
    let topControlsFormData = { ...state[topControlsStateName] };
    let value = (event.target.type=="checkbox") ? event.target.checked : event.target.value;
    let returnState = {};
    
    topControlsFormData[event.target.id] = value;
    returnState[topControlsStateName] = topControlsFormData;
    state.searchTimeoutObject = InterfaceTooling.delayCallAction(fetchListSearch, timeoutObject);
    
    return returnState;
  }
};

export default EntityTableToolingOld;


// WEBPACK FOOTER //
// ./source/tooling/entityTableToolingOld.js